import Axios from 'axios';
import Qs from 'qs';

export default {

  // 角色分页列表
  listPage(
    title,
    type,
    page,
    limit
  ) {
    return Axios.get('/base/api/admin/roles', {
      params: {
        title,
        type,
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 添加角色
  add(
    title,
    type,
    describe
  ) {
    return Axios.post('/base/api/admin/roles', {
      title,
      type,
      describe
    });
  },

  // 编辑角色
  edit(
    id,
    title,
    type,
    describe
  ) {
    return Axios.patch(`/base/api/admin/roles/${id}`, {
      title,
      type,
      describe
    });
  },

  // 删除角色
  del(
    id
  ) {
    return Axios.delete(`/base/api/admin/roles/${id}`);
  },

  // 角色信息
  info(
    id
  ) {
    return Axios.get(`/base/api/admin/roles/${id}`);
  },

  // 分配菜单
  assignMenu(
    id,
    permissions
  ) {
    return Axios.post(`/base/api/admin/role-permission/${id}`, {
      permissions
    });
  }

}